var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowCircleSmall = function SvgArrowCircleSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#fff",
    stroke: "#25241D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14 10.664 6 5.333-6 5.334",
    stroke: "#17294D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgArrowCircleSmall as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIzMSIgaGVpZ2h0PSIzMSIgcng9IjE1LjUiIGZpbGw9IndoaXRlIiBzdHJva2U9IiMyNTI0MUQiLz4KPHBhdGggZD0iTTE0IDEwLjY2NDFMMjAgMTUuOTk3NEwxNCAyMS4zMzA3IiBzdHJva2U9IiMxNzI5NEQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";